import React, {useRef, useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components';
import { ImCross } from "react-icons/im"
import LoadingDotsComp from '../LoadingDotsComp';
import Button from "../Button";
import SmallButton from "../SmallButton";
import InputComp from "../InputComp"
import Logo from "../../assets/logo.png"

interface PropI{
  setshow:(x:boolean)=>void;
}

const AIDemo : React.FC<PropI>=({setshow})=>{

    const divRef = useRef<any>(null);
    const inputRef = useRef<any>(null);
    const questionRef = useRef<any>("")
    const [ waitingforanswer, setwaitingforanswer ] = useState(false)
    const [ questionidx, setquestionidx ] = useState(0)
    
    const [allquestions, setallquestions] = useState(["What is MiAmigo.ai?", "How to use MiAmigo chatbot?", "What does subscription to MiAmigo chatbot cost?"])
    const [ answers, setanswers ] = useState([
      `<NameSpan style="font-weight: 700;">Chatbot </NameSpan>MiAmigo.ai is an AI chat assistant plugin that can be added to any website in minutes!`,
      `<NameSpan style="font-weight: 700;">Chatbot </NameSpan>To use MiAmigo.ai chatbot <ol><li>Register an account</li><li>Choose your subscription level</li><li>Add javascript to your webpage to launch the chatbot</li></ol>`,
      `<NameSpan style="font-weight: 700;">Chatbot </NameSpan>There are 3 levels of subscription<ul><li>Basic: Free</li><li>Preferred: $10/month</li><li>Premium: $20/month</li></ul>`
    ])
    

    const [ togglestate, settogglestate ] = useState(false)
    
    const [ currentIndex, setcurrentIndex ] = useState(0)

    const [messages, setmessages] = useState<[any]>([{user:"Chatbot", message:`<NameSpan style="font-weight: 700;">Chatbot </NameSpan>Hello, I am you your virtual assistant please ask any question you may have and I will try to answer it to best of my knowledge.`}])

    useEffect(() => {
      divRef.current?.scrollIntoView({behavior:"smooth"})
    })

    useEffect(()=>{
      divRef.current?.scrollIntoView({behavior:"smooth"})
    }, [divRef, messages, waitingforanswer])
    
    useEffect(() => {
      const typeNextLetter = () => {
          // inputRef.current.focus()
          // inputRef.current.select()
          divRef.current.scrollIntoView({ behavior: "smooth" });
        
          if (currentIndex < allquestions[questionidx].length) {
              questionRef.current = questionRef.current + allquestions[questionidx].charAt(currentIndex);
              setcurrentIndex( currentIndex + 1);
          }else{
            let msg: any = {user:"Guest", message:questionRef.current.toString()}
            messages.push(msg)
            setmessages(messages)
            settogglestate(!togglestate)
            questionRef.current = ""
            setwaitingforanswer(true)
            setTimeout(()=>{
              getAnswer()
              setwaitingforanswer(false)
              setTimeout(()=>{
                if(questionidx+1<allquestions.length)
                {
                  setquestionidx(questionidx+1)
                  setcurrentIndex(0)
                  questionRef.current = ""
                }else{
                  setTimeout(()=>{
                    setquestionidx(0)
                    setcurrentIndex(0)
                    questionRef.current = ""
                    setmessages([{user:"Chatbot", message:`<NameSpan style="font-weight: 700;">Chatbot </NameSpan>Hello, I am you your virtual assistant please ask any question you may have and I will try to answer it to best of my knowledge.`}])
                  }, 5000)
                }
              }, 1000)
            }, 3000)
          }
      }

      const getAnswer = () => {
          let msg: any = {user:"Chatbot", message: answers[questionidx]}
          messages.push(msg)
      }

      const timer = setTimeout(() => {
          typeNextLetter();
      }, 100)

      return () => {
          clearTimeout(timer); // Clear the timer when component unmounts
      };
  }, [currentIndex, divRef]);


    useEffect(()=>{
    }, [togglestate])

  return(
    <>
        <Chatpopup>
            <SmallBtn style={{alignSelf:'flex-end',position:"relative", top:"5px", zIndex:100,  backgroundColor:"#FFFFFF"}} onClick={()=>{setshow(false)}}><ImCross fontSize={"20px"} color={"#5faad4"}/></SmallBtn>
            <HeaderContainer style={{position:"relative", top:"-45px"}}>
            <svg width="0" height="0">
            <defs>
                <clipPath id="myCurve" clipPathUnits="objectBoundingBox">
                <path
                    d="M 0,1
                    L 0,0
                    L 1,0
                    L 1,0.98
                    C .9 0.65, .5 .9, 0.4 0.95
                    C .25 1, .15 .8, 0 0.75
                    Z"
                />
                </clipPath>
            </defs>
            </svg>
            <div style={{position:"absolute", top:"5px", zIndex:100}}>
              
            <Header style={{display: 'flex', alignItems:"center"}}>
              <img src={Logo} width={"35px"}/> 
              Chatbot - Demo</Header>
            <Text><NameSpan>Phone:</NameSpan> &nbsp;(555) 555-5555</Text>
            <Text><NameSpan>Email:</NameSpan> &nbsp;support@miamigo.ai</Text>
            </div>
            </HeaderContainer>

            <ChatOutput>
                {
                messages.map((v: any, id: any)=>(
                    v['user']=="Chatbot"?
                    <TalkBubbleHD key={`hd${id}`} dangerouslySetInnerHTML={{ __html: ` ${v['message']}` }} />
                    :
                    <TalkBubbleG key={`hd${id}`} ><NameSpan>You</NameSpan> {v['message']}</TalkBubbleG>
                ))
                }
                {
                waitingforanswer?
                    <LoadingDotsComp />
                :<></>
                }
                <div key={messages.length} ref={divRef}></div>
            </ChatOutput>
            {!waitingforanswer?
            <ButtonDiv style={{justifyContent: "flex-start"}}>
                <Text>Was the response helpful?</Text>
                <SmallButton text="YES" handleClick={()=>{}} backgroundColor={"#5faad4"} color={"#000"}/>
                <SmallButton text="NO" handleClick={()=>{}} backgroundColor={"#BF406B"} color={"#000"} />
                <SmallButton text="Email" handleClick={()=>{}} backgroundColor={"#5faad4"} color={"#000"} />
            </ButtonDiv>
            :<></>}
            <ButtonDiv>

                <InputComp id="question" placeholder='enter your message' value={questionRef.current} onChange={(e: any)=>{}} width={300}/>
                <Button handleClick={()=>{}} text="Send" backgroundColor={"#5faad4"}/>
                
            </ButtonDiv>
            <div style={{display:'flex', alignItems: 'center', padding:"5px", fontSize:"12px", }}>Powered by <a style={{display:'flex', alignItems: 'center', color:"#5faad4", fontWeight:700}} href="https://miamigo.ai" target='__blank'>
              <img src={Logo} width={"20px"} />
              Miamigo.ai</a>&nbsp; beta</div>

            
        </Chatpopup>
    </>
  );
}

const Slidein = keyframes`
  0% {
    transform: translateY(100%)
  }
  100% {
    transform: translateY(0%)
  }
`;

const Chatpopup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #000000;
    height: 700px;
    // height: 600px;
    width: 90%;
    max-width: 350px;
    text-align: left;
    background-color: rgb(240, 240, 240);
    position: fixed;
    bottom: 1%;
    right: 1%;
    border: 3px solid #f1f1f1;
    border-radius: 20px 0px 0px 0px;
    z-index: 10;
    animation: ${Slidein} 0.5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    box-shadow: 0 2px 4px 2px rgba(100, 100, 100, 1);
`;

const HeaderContainer = styled.div`
  width: 100%;
  background: #5faad4;
  border-radius: 20px 0px 5px 0px;
  padding: 7px;
  margin: 0;
  margin-bottom: 3px;
  height: 145px;
  clip-path: url(#myCurve);
`;

const Header = styled.div`
    font-size: 25px;
    font-weight: 600;
    color: #FFFFFF;
    padding: 7px;
`;

const Text = styled.div`
  font-size: 12px;
  margin: 3px 0;
  padding: 0 7px;
  `;

const ButtonDiv = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const TalkBubbleG = styled.div`
    display: inline-block;
    position: relative;
    align-self: flex-end;
    background-color: #afd5ea;
    color: #000000;
    border-radius: 10px 10px 0px 10px;
    margin: 9px;
    padding: 10px;
    font-size: 13px;
    line-height: 1.5;
    word-wrap: break-word;
    overflow-wrap: break-word;
    width: 75%;
    box-shadow: 0 2px 4px 2px rgba(100, 100, 100, 1);
`;

const TalkBubbleHD= styled.div`
  display: inline-block;
  position: relative;
  background-color: #f1f1f1;
  color: #000000;
  border-radius: 10px 10px 10px 0px;
  padding: 10px;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 9px;
  box-shadow: 0 2px 4px 2px rgba(100, 100, 100, 1);
  width: 75%;
  white-space: pre-wrap;
`;

const ChatOutput = styled.div`
    display: flex;
    flex-direction: column;
    background-color: rgb(240, 240, 240);
    overflow-y: scroll;
    height: 400px;
    width: 100%;
    border-radius: 5px 0 0 5px;
    padding: 7px;
    white-space: pre-wrap;
`;

const NameSpan = styled.span`
    font-weight: 700;
`;

const SmallBtn = styled.div`
    margin: 5px;
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    text-transform: uppercase;
    padding: 7px;
    font-weight: 500;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(100, 100, 100, 0.25);
    background-color: #0F2557;
    color: #FFFFFF;
    width: auto
    transition: ease 0.5s;
    &:hover {
        box-shadow: 0 2px 4px 2px rgba(100, 100, 100, 1);
    }
`

export default AIDemo